<script>
import Toolbar from "../shape/Toolbar.vue"
export default Toolbar
</script>